import {Component, OnInit, ViewChild} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {ApiService} from "../../../services/api.service";
import {SearchGrantsService} from "../services/search-grants.service";
import {HttpErrorResponse} from "@angular/common/http";
import {SearchGrantsFilterDto} from "../../../models/search-grants-filter-dto";
import {saveAs} from 'file-saver';
import {SearchService} from "../../search-nonprofits-donors/services/search.service";
import {UserService} from "../../users/services/users.service";
import {StPagination2Component} from "../../../shared-components/ui-components/st-pagination/st-pagination2.component";
import {PageChangeDto} from "../../../models/page-change-dto";
import {Auth2Service} from "../../../services/auth2.service";
import {LoggedInPageBaseComponent} from "../../../shared-components/ui-components/logged-in-page-base/logged-in-page-base.component";
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'app-search-grants-page',
  templateUrl: './search-grants-page.component.html',
  styleUrls: ['./search-grants-page.component.scss'],
  standalone: false
})
export class SearchGrantsPageComponent extends LoggedInPageBaseComponent implements OnInit {

  breadCrumbs = [
    { iconClass: 'bi-house', path: 'app/users/dashboard'},
    { label: 'Dashboard', path: 'app/users/dashboard'},
    { label: 'Search Grants'}
  ];

  pageNameBase: string = 'Search Grants';
  pageName: string = this.pageNameBase;
  isSideNavOpened: boolean = false;
  platform: string = '';
  loadingIcon = false;

  username: string = '';
  impersonatedEmail: any = null;
  consultantRoleName: any = null;
  emailCodeVerifiedFlag: string = 'N';
  subscriptionActive: boolean = false;
  pilotTrialVerified: boolean = false;
  customerTrialVerified: boolean = false;

  savedSearchArray: any[] = [];
  currentSavedSearchDto: any = null;
  searchTypeNameMap: any = {};

  rows: any[] = [];

  recipientNames: string[] = [];
  eins: string[] = [];

  states: string[] = [];
  cities: string[] = [];
  citiesWithout: string[] = [];
  grantAmtMin: number = -1;
  grantAmtMax: number = -1;
  taxYear: number = -1;
  cause: string = '';

  statesList: any[] = [];

  taxYearsRadioButtons: any[] = [
    {
      "taxYear": 2025,
      "checked": false
    }, {
      "taxYear": 2024,
      "checked": true
    },{
      "taxYear": 2023,
      "checked": false
    },{
      "taxYear": 2022,
      "checked": false
    },{
      "taxYear": 2021,
      "checked": false
    },{
      "taxYear": 2020,
      "checked": false
    },{
      "taxYear": 2019,
      "checked": false
    },{
      "taxYear": 2018,
      "checked": false
    }
  ];
  taxYearsButton: any = true;


  causeGivingInterestsList: string[] = [];
  causeGivingInterestsWithoutList: string[] = [];

  givingInterestsSetObj: any = {};
  givingInterestsWithoutSetObj: any = {};

  causeDropdownList: any[] = [];
  causeGivingInterestsObj: any = {};
  causeGivingInterestsDropdownList: any[] = [];

  artsCultureList: string[] = [];
  communityDevelopmentList: string[] = [];
  educationList: string[] = [];
  environmentList: string[] = [];
  healthList: string[] = [];
  internationalGivingList: string[] = [];
  religionList: string[] = [];
  socialHumanServicesList: any[] = [];
  sportsRecreationList: any[] = [];

  savedSearchModal: any = null;
  savedSearchOpenModalBtn1: HTMLElement | null = null;
  savedSearchOpenModalBtn2: HTMLElement | null = null;
  savedSearchCloseSpan: HTMLElement | null = null;

  errorMessages: any[] = [];

  successMessages: any[] = [];

  logicalOperatorAnd: boolean = false;
  logicalOperatorOr: boolean = true;

  recipientNameAscRadioButton: boolean = false;
  recipientNameDescRadioButton: boolean = false;
  sortByRecipientNameAscId: number = 0

  cityAscRadioButton: boolean = false;
  cityDescRadioButton: boolean = false;
  sortByCityAscId: number = 0;

  stateAscRadioButton: boolean = false;
  stateDescRadioButton: boolean = false;
  sortByStateAscId: number = 0;

  grantAmountAscRadioButton: boolean = false;
  grantAmountDescRadioButton: boolean = false;
  sortByGrantAmtAscId: number = 0;

  sortedAscRecipientOfGrantHeaderButton: boolean = false;
  sortedAscCityHeaderButton: boolean = false;
  sortedAscStateHeaderButton: boolean = false;
  sortedAscCashGrantAmtHeaderButton: boolean = false;

  citiesAutocomplete: any[] = [];
  recipientNamesAutocomplete: any[] = [];

  @ViewChild('grantspaginator') stPaginator2Component!: StPagination2Component;
  collectionSize: number = 0;
  page: number = 1;
  pageSize: number = 100;
  customPageSizes = [
    {
      "pageSizeId" : 50,
      "pageSize": 50
    }, {
      "pageSizeId" : 100,
      "pageSize": 100
    }, {
      "pageSizeId" : 250,
      "pageSize": 250
    }, {
      "pageSizeId" : 500,
      "pageSize": 500
    }
  ];

  showSideNavErrorMessages: boolean = false;
  sideNavErrorMessages: any[] = [];
  showSideNavSuccessMessages: boolean = false;
  sideNavSuccessMessages: any[] = [];

  constructor(private auth2ServiceChild: Auth2Service, private apiService: ApiService, private searchGrantsService: SearchGrantsService,
              private routerChild: Router, private route: ActivatedRoute, private searchService: SearchService,
              private userService: UserService,
              private titleService: Title) {
    super(auth2ServiceChild, routerChild);
    this.titleService.setTitle("Scalanthropy Search Grants")
  }

  loadSearchTypeNameMap(): void {
    this.searchService.getSearchTypeNamesDropdown(this.username)
      .subscribe((result: any) => {
        if (result && result.body) {
          for (const searchTypeNameTemp of result.body){
            this.searchTypeNameMap[searchTypeNameTemp.searchTypeName] = searchTypeNameTemp.searchTypeId;
          }
        }
        return;
      }, (err: HttpErrorResponse) => {
        this.redirectToLogin(err)
        this.pageErrorMessages.push({
          field: 'Search Grant API Error',
          detail: 'Failed to pull the Search Type Names...',
          severity: 'error'
        });
        this.showErrorMessagesToUser();
        return;
      });
    return;
  }

  ngOnInit(): void {
    // @ts-ignore
    this.username = this.auth2ServiceChild.getUsername();
    this.impersonatedEmail = this.auth2ServiceChild.getImpersonatedEmail();
    this.consultantRoleName = this.auth2ServiceChild.getConsultantRoleName();
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" })
    this.emailCodeVerifiedFlag = this.auth2ServiceChild.getEmailCodeVerifiedFlag()
    if (this.emailCodeVerifiedFlag != 'Y') {
      this.routerChild.navigateByUrl('app/users/emails/verify')
      return;
    } else {
      this.userService.getSubscriptionVerification(this.username, this.impersonatedEmail).subscribe(
        (verificationResult: any) => {
          this.subscriptionActive = verificationResult.body.verified;
          this.pilotTrialVerified = verificationResult.body.pilotTrialVerified;
          this.customerTrialVerified = verificationResult.body.customerTrialVerified;

          //Begin initializing page
          this.populateFilters();
          this.setUpSavedSearchModal();
          this.loadSearchTypeNameMap();
          const delayedSetup = () => {
            this.setUpSavedSearchModal();
            this.getSavedSearches();
            const lastSearchJsonString = localStorage.getItem('lastSearchGrant');
            if (lastSearchJsonString) {
              // @ts-ignore
              const lastSearchFilter: any = JSON.parse(lastSearchJsonString);
              this.loadFiltersFromLastSearch(lastSearchFilter);
            }
          }
          setTimeout(delayedSetup, 4000);
          this.platform = navigator.userAgent;

          if (this.platform) {
            this.platform = this.platform.toLowerCase();
          }
        }, (error:HttpErrorResponse) => {
          this.redirectToLogin(error);
          this.pageErrorMessages.push({
            field: 'Subscription Error',
            detail: 'This feature is not available for inactive subscriptions. Please activate your subscription.',
            severity: 'error'
          });
          this.showPageErrorMessagesToUser();
        }
      );
    }
  }

  showSideNavErrorMessagesToUser(): void {
    this.showSideNavErrorMessages = true;
    const counterFn = () => {
      this.showSideNavErrorMessages = false;
    }
    setTimeout(counterFn, 8000);
  }

  showSideNavSuccessMessagesToUser(): void {
    this.showSideNavSuccessMessages = true;
    const counterFn = () => {
      this.showSideNavSuccessMessages = false;
    }
    setTimeout(counterFn, 8000);
  }
  getSavedSearches(): void {
    this.userService.getAllSavedSearches(this.username, 'GRANT_SEARCH', this.impersonatedEmail)
      .subscribe(
        (result: any) => {
          if (result && result.body) {
            this.savedSearchArray = result.body;
          }
        }, (err: HttpErrorResponse) => {
          this.redirectToLogin(err);
          this.pageErrorMessages.push({
            field: 'Failed retrieve Grants savedSearches',
            detail: 'Failed retrieve Grants savedSearches. Please try again.',
            severity: 'error'
          });
          this.showPageErrorMessagesToUser();
        }
      )
  }
  changePageResults(pageChangeDto: PageChangeDto): void {
    this.pageErrorMessages = [];
    this.pageSuccessMessages = [];
    this.sideNavErrorMessages = [];
    let updatePageValue: number = 0
    if (pageChangeDto) {
      updatePageValue = pageChangeDto["page"];
      this.pageSize = pageChangeDto["pageSize"]
    }
    // @ts-ignore
    let filter: string = localStorage.getItem('lastSearchGrant');
    const lastSearchFilter: any = JSON.parse(filter);
    this.loadingIcon = true;
    this.searchGrantsService.getGrantsPages(lastSearchFilter, updatePageValue, this.pageSize, this.username)
      .subscribe((result : any) => {
        if (result && result.body) {
          this.rows = result.body.dtos;
          this.page = updatePageValue
          this.collectionSize = result.body.collectionSize
        }
        this.loadingIcon = false;
      }, (err: HttpErrorResponse) => {
        this.redirectToLogin(err);
        this.pageErrorMessages.push({
          field: 'Failed to pull the last search grant results',
          detail: 'Failed to pull the last search grant results. Please try again.',
          severity: 'error'
        });
        this.showPageErrorMessagesToUser();
        this.loadingIcon = false;
      })
  }

  onApplySavedSearch(): void {
    this.pageErrorMessages = [];
    this.pageSuccessMessages = [];
    this.sideNavErrorMessages = [];
    let savedSearchEl = document.getElementById('saved-search-selector-id');
    // @ts-ignore
    let savedSearchId: number = savedSearchEl.value;
    let i: number = 0;
    let foundFlag: boolean = false;
    for (const savedSearchObj of this.savedSearchArray) {
      if (savedSearchObj.savedSearchId == savedSearchId) {
        foundFlag = true;
        break;
      }
      i = i + 1;
    }
    if (!foundFlag) {
      this.sideNavErrorMessages.push({
        field: 'Cannot apply an empty saved search',
        detail: 'Please enter a saved filter.',
        severity: 'error'
      });
      this.showSideNavErrorMessagesToUser();
      return;
    }
    this.page = 1;
    this.pageSize = 100;

    //Expire 2 hours from now
    let expirationTimestamp: number = Date.now() + 1000*3600*2;
    localStorage.setItem('lastSearchGrant', this.savedSearchArray[i].savedSearchJson);
    localStorage.setItem('lastSearchGrantExpTime', expirationTimestamp.toString());
    const browserUrl: string = window.location.href;
    this.executeSearchPages(browserUrl, this.page, this.pageSize, JSON.parse(this.savedSearchArray[i].savedSearchJson),
      this.username);
  }

  populateGrantsCities(): void {
    // @ts-ignore
    let grantCitiesCacheExpTimeStr: string = localStorage.getItem('grantCitiesCacheExpTime');
    if (!grantCitiesCacheExpTimeStr) {
      //expire the cached search
      localStorage.removeItem('grantCitiesCache');
    } else {
      let grantExpTime: number = parseInt(grantCitiesCacheExpTimeStr);
      let now = Date.now();
      if (now >= grantExpTime) {
        //expire the cached search
        localStorage.removeItem('grantCitiesCache');
      }
    }
    const grantCitiesCacheJsonString = localStorage.getItem('grantCitiesCache');
    if (!grantCitiesCacheJsonString) {
      this.searchGrantsService.getGrantsCities(this.username).subscribe((result: any) => {
        if (result && result.body) {
          let i: number = 0;
          while (i < result.body.size) {
            this.citiesAutocomplete.push(result.body.citiesStates[i]);
            i = i + 1;
          }
          let expirationTimestamp: number = Date.now() + 1000*3600*8;
          localStorage.setItem('grantCitiesCacheExpTime', expirationTimestamp.toString());
          localStorage.setItem('grantCitiesCache', JSON.stringify(this.citiesAutocomplete));
        }
      }, (error: HttpErrorResponse) => {
        this.pageErrorMessages.push({
          field: 'Search Grants Error',
          detail: 'Failed to pull Grants Recipients cities.',
          severity: 'error'
        });
        this.showPageErrorMessagesToUser();
      })
    } else {
      this.citiesAutocomplete = JSON.parse(grantCitiesCacheJsonString);
    }
  }

  populateGrantsRecipientNames(): void {
    this.searchGrantsService.getGrantsRecipientNames(this.username).subscribe((result: any) => {
      if (result && result.body) {
        let i: number = 0;
        while (i < result.body.length) {
          this.recipientNamesAutocomplete.push(result.body[i]);
          i = i + 1;
        }
      }
    }, (error: HttpErrorResponse) => {
      this.pageErrorMessages.push({
        field: 'Search Grants Error',
        detail: 'Failed to pull Grants Recipients names.',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
    })
  }

  populateFilters(): void {
    this.populateUSAStates();
    this.populateGrantsCities();
    //this.populateGrantsRecipientNames();
    //this.populateTaxYearsRadioButtons();
    this.populateCausesDropdown();
    this.populateResultsFromLastSearch(false);
  }

  setUpSavedSearchModal(): void {
    // Get the modal
    this.savedSearchModal = document.getElementById("saved-search-modal-id");

    // Get the button that opens the modal
    // @ts-ignore
    this.savedSearchOpenModalBtn1 = document.getElementById("saved-search-modal-button1-id");
    this.savedSearchOpenModalBtn2 = document.getElementById("saved-search-modal-button2-id");
    // Get the <span> element that closes the modal
    this.savedSearchCloseSpan = document.getElementsByClassName("close")[0] as HTMLElement;
  }

  openSavedSearchModal(): boolean {
    this.closeNav();
    // @ts-ignore
    this.savedSearchModal.style.display = "block";
    return true;
  }
  closeSavedSearchModal(): boolean {
    // @ts-ignore
    this.savedSearchModal.style.display = "none";
    return true;
  }

  clearResultsAndFilter(): boolean {
    this.resetAllFiltersModal();
    this.collectionSize = 0;
    this.page = 1;
    this.rows = [];
    this.stPaginator2Component.initPages(this.collectionSize, this.pageSize);
    localStorage.removeItem('lastSearchGrant');
    localStorage.removeItem('lastSearchGrantExpTime');
    return true;
  }

  resetAllFiltersModal(): boolean {
    this.loadingIcon = false;
    this.showErrorMessages = false;
    this.errorMessages = [];
    this.showSuccessMessages = false;
    this.successMessages = [];
    //Build search dto from checkboxes
    this.recipientNames = [];
    const recipientNameEl = document.getElementById('search-grant-names-text-id');
    // @ts-ignore
    recipientNameEl.value = '';

    this.eins = [];
    const einsEl = document.getElementById('eins-text-id');
    // @ts-ignore
    einsEl.value = ''

    this.cities = [];
    const citiesEl = document.getElementById('cities-text-id');
    // @ts-ignore
    citiesEl.value = '';

    this.citiesWithout = [];
    /*
    const citiesWithoutEl = document.getElementById('cities-without-text-id');
    // @ts-ignore
    citiesWithoutEl.value = '';*/

    this.states = [];
    const usaStateEl = document.getElementById('usa-dropdown-list-id');
    // @ts-ignore
    usaStateEl.value = '';

    this.grantAmtMin = -1;
    const grantAmtMinEl = document.getElementById('grant-amt-min-text-id');
    // @ts-ignore
    grantAmtMinEl.value = '';

    this.grantAmtMax = -1;
    const grantAmtMaxEl = document.getElementById('grant-amt-max-text-id');
    // @ts-ignore
    grantAmtMaxEl.value = '';

    const causeCategorySel = document.getElementById("cause-category-dropdown-list-id");
    // @ts-ignore
    causeCategorySel.value = '';

    const causeGivingInterestEl = document.getElementById('cause-giving-interests-dropdown-list-id');
    // @ts-ignore
    causeGivingInterestEl.value = '';

    //Time Varying Parameters
    //Tax Year Filter
    for (const taxYearsRadioButtonTemp of this.taxYearsRadioButtons) {
      taxYearsRadioButtonTemp.checked = false;
    }
    //default to latest tax year
    this.taxYearsRadioButtons[1].checked = true

    //Cause filter
    this.cause = '';

    //Giving Interests build list
    this.causeGivingInterestsList = [];
    this.givingInterestsSetObj = {};

    //Giving Interests Without build list
    this.causeGivingInterestsWithoutList = [];
    this.givingInterestsWithoutSetObj = {};

    this.recipientNameAscRadioButton = false;
    this.recipientNameDescRadioButton = false;
    this.sortByRecipientNameAscId = 0

    this.cityAscRadioButton = false;
    this.cityDescRadioButton = false;
    this.sortByCityAscId = 0;

    this.stateAscRadioButton = false;
    this.stateDescRadioButton = false;
    this.sortByStateAscId = 0;

    this.grantAmountAscRadioButton = false;
    this.grantAmountDescRadioButton = false;
    this.sortByGrantAmtAscId = 0;

    this.sortedAscRecipientOfGrantHeaderButton = false;
    this.sortedAscCityHeaderButton = false;
    this.sortedAscStateHeaderButton = false;
    this.sortedAscCashGrantAmtHeaderButton = false;

    return true;
  }

  populateResultsFromLastSearch(newSort: boolean = false): void {
    // @ts-ignore
    let lastSearchGrantExpTimeStr: string = localStorage.getItem('lastSearchGrantExpTime');
    if (!lastSearchGrantExpTimeStr) {
      //expire the cached search
      localStorage.removeItem('lastSearchGrant');
    } else {
      let lastSearchGrantExpTime: number = parseInt(lastSearchGrantExpTimeStr);
      let now = Date.now();
      if (now >= lastSearchGrantExpTime) {
        //expire the cached search
        localStorage.removeItem('lastSearchGrant');
      }
    }
    const lastSearchJsonString = localStorage.getItem('lastSearchGrant');
    if (lastSearchJsonString) {
      // @ts-ignore
      const lastSearchFilter: any = JSON.parse(lastSearchJsonString);
      const username = localStorage.getItem('username');
      const browserUrl: string = window.location.href;
      if (newSort) {
        this.page = 1;
        this.sortByRecipientNameAscId = 0;
        if (this.recipientNameAscRadioButton) {
          this.sortByRecipientNameAscId = 1;
        } else if (this.recipientNameDescRadioButton) {
          this.sortByRecipientNameAscId = 2;
        }

        this.sortByCityAscId = 0;
        if (this.cityAscRadioButton) {
          this.sortByCityAscId = 1;
        } else if (this.cityDescRadioButton) {
          this.sortByCityAscId = 2;
        }

        this.sortByStateAscId = 0;
        if (this.stateAscRadioButton) {
          this.sortByStateAscId = 1;
        } else if (this.stateDescRadioButton) {
          this.sortByStateAscId = 2;
        }

        this.sortByGrantAmtAscId = 0;
        if (this.grantAmountAscRadioButton) {
          this.sortByGrantAmtAscId = 1;
        } else if (this.grantAmountDescRadioButton) {
          this.sortByGrantAmtAscId = 2;
        }
        lastSearchFilter['sortByRecipientNameAsc'] = this.sortByRecipientNameAscId;
        lastSearchFilter['sortByCityAsc'] = this.sortByCityAscId;
        lastSearchFilter['sortByStateAsc'] = this.sortByStateAscId;
        lastSearchFilter['sortByGrantAmtAsc'] = this.sortByGrantAmtAscId
      }
      localStorage.setItem('lastSearchGrant', JSON.stringify(lastSearchFilter));
      this.loadFiltersFromLastSearch(lastSearchFilter)
      // @ts-ignore
      this.executeSearchPages(browserUrl, this.page, this.pageSize, lastSearchFilter, username);
    }
  }

  loadFiltersFromLastSearch(grantSearchJson: any) {
    if (grantSearchJson['recipientNames']) {
      this.recipientNames = grantSearchJson['recipientNames'];
      const grantNameInputEl = document.getElementById('search-grant-names-text-id');
      if (this.recipientNames.length > 0) {
        // @ts-ignore
        grantNameInputEl.value = this.recipientNames.join(',');
      } else {
        // @ts-ignore
        grantNameInputEl.value = '';
      }
    }
    this.states = [];
    if (grantSearchJson['state']) {
      this.states.push(grantSearchJson['state']);
      const usaStateDropdownEl = document.getElementById('usa-dropdown-list-id');
      // @ts-ignore
      usaStateDropdownEl.value = this.states[0];
    }
    if (grantSearchJson['states']) {
      if (grantSearchJson['states'].length > 0) {
        this.states.push(grantSearchJson['states'][0]);
        const usaStateDropdownEl = document.getElementById('usa-dropdown-list-id');
        // @ts-ignore
        usaStateDropdownEl.value = this.states[0];
      }
    }
    if (grantSearchJson['eins']) {
      this.eins = grantSearchJson['eins'];
      const grantEinsInputEl = document.getElementById('eins-text-id');
      if (this.eins.length > 0) {
        // @ts-ignore
        grantEinsInputEl.value = this.eins.join(',');
      } else {
        // @ts-ignore
        grantEinsInputEl.value = '';
      }
    }
    if (grantSearchJson['cities']) {
      this.cities = grantSearchJson['cities'];
      const grantCitiesInputEl = document.getElementById('cities-text-id');
      if (this.cities.length > 0) {
        // @ts-ignore
        grantCitiesInputEl.value = this.cities.join(',');
      } else {
        // @ts-ignore
        grantCitiesInputEl.value = '';
      }
    }
    /*
    if (grantSearchJson['citiesWithout']) {
      this.citiesWithout = grantSearchJson['citiesWithout'];
      const grantCitiesWithoutInputEl = document.getElementById('cities-without-text-id');
      if (this.citiesWithout.length > 0) {
        // @ts-ignore
        grantCitiesWithoutInputEl.value = this.citiesWithout.join(',');
      } else {
        // @ts-ignore
        grantCitiesWithoutInputEl.value = '';
      }
    }*/

    if (grantSearchJson['grantAmtMin']) {
      const grantAmtMinEl = document.getElementById('grant-amt-min-text-id');
      if (grantSearchJson['grantAmtMin'] == -1) {
        this.grantAmtMin = -1;
        // @ts-ignore
        grantAmtMinEl.value = '';
      } else {
        this.grantAmtMin = grantSearchJson['grantAmtMin'];
        // @ts-ignore
        grantAmtMinEl.value = this.grantAmtMin;
      }
    }
    if (grantSearchJson['grantAmtMax']) {
      const grantAmtMaxEl = document.getElementById('grant-amt-max-text-id');
      if (grantSearchJson['grantAmtMax'] == -1) {
        this.grantAmtMax = -1;
        // @ts-ignore
        grantAmtMaxEl.value = '';
      } else {
        this.grantAmtMax = grantSearchJson['grantAmtMax'];
        // @ts-ignore
        grantAmtMaxEl.value = this.grantAmtMax;
      }
    }

    if (grantSearchJson['taxYear']) {
      let i: number = 0;
      let taxYearLength: number =  this.taxYearsRadioButtons.length;
      while (i < taxYearLength) {
        this.taxYearsRadioButtons[i].checked = false;
        i = i + 1;
      }
      i = 0;
      while (i < taxYearLength) {
        if (this.taxYearsRadioButtons[i].taxYear === grantSearchJson['taxYear']) {
          this.taxYearsRadioButtons[i].checked = true;
          break;
        }
        i = i + 1;
      }
    }

    this.causeGivingInterestsList = [];
    if (grantSearchJson['causeGivingInterests'] && grantSearchJson['causeGivingInterests'].length > 0) {
      for (const causeGivingInterest of grantSearchJson['causeGivingInterests']) {
        this.causeGivingInterestsList.push(causeGivingInterest);
      }
    }

    this.causeGivingInterestsWithoutList = [];
    /*
    if (grantSearchJson['causeGivingInterestsWithout'] && grantSearchJson['causeGivingInterestsWithout'].length > 0) {
      for (const causeGivingInterest of grantSearchJson['causeGivingInterestsWithout']) {
        this.causeGivingInterestsWithoutList.push(causeGivingInterest);
      }
    }*/

    this.recipientNameAscRadioButton = false;
    this.recipientNameDescRadioButton = false;
    if (grantSearchJson['sortByRecipientNameAsc']) {
      if (grantSearchJson['sortByRecipientNameAsc'] == 1) {
        this.recipientNameAscRadioButton = true;
      } else if (grantSearchJson['sortByRecipientNameAsc'] == 2) {
        this.recipientNameDescRadioButton = true;
      }
    }

    this.cityAscRadioButton = false;
    this.cityDescRadioButton = false;
    if (grantSearchJson['sortByCityAsc']) {
      if (grantSearchJson['sortByCityAsc'] == 1) {
        this.cityAscRadioButton = true;
      } else if (grantSearchJson['sortByCityAsc'] == 2) {
        this.cityDescRadioButton = true;
      }
    }

    this.stateAscRadioButton = false;
    this.stateDescRadioButton = false;
    if (grantSearchJson['sortByStateAsc']) {
      if (grantSearchJson['sortByStateAsc'] == 1) {
        this.stateAscRadioButton = true;
      } else if (grantSearchJson['sortByStateAsc'] == 2) {
        this.stateDescRadioButton = true;
      }
    }

    this.grantAmountAscRadioButton = false;
    this.grantAmountDescRadioButton = false;
    if (grantSearchJson['sortByGrantAmtAsc']) {
      if (grantSearchJson['sortByGrantAmtAsc'] == 1) {
        this.grantAmountAscRadioButton = true;
      } else if (grantSearchJson['sortByGrantAmtAsc'] == 2) {
        this.grantAmountDescRadioButton = true;
      }
    }
  }

  /**
   * Used for first load of search filter and when actual search filter changes
   * @param browserUrl
   * @param page
   * @param pageSize
   * @param filter
   * @param username
   */
  executeSearchPages(browserUrl: string, page: number, pageSize: number, filter: any, username: string): void {
    this.closeNav();
    this.pageErrorMessages = [];
    this.pageSuccessMessages = [];
    this.sideNavErrorMessages = [];
    this.loadingIcon = true;
    this.searchGrantsService.getGrantsPages(filter, page, pageSize, username).subscribe((result: any) => {
      if (result && result.body) {
        this.collectionSize = result.body.collectionSize;
        this.page = result.body.page;
        this.rows = result.body.dtos;
        this.stPaginator2Component.initPages(this.collectionSize, this.pageSize);
      }
      this.loadingIcon = false;
    }, (error: HttpErrorResponse) => {
      this.redirectToLogin(error);
      this.pageErrorMessages.push({
        field: 'Search Grants Error',
        detail: 'Failed to search grants. Please try again.',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
      this.loadingIcon = false;
    });
  }

  populateUSAStates(): void {
    this.statesList = [];
    this.searchGrantsService.getUSAStatesDropdown().subscribe((result: any) => {
      if (result && result.body) {
        //this.statesList = result.body;
        let i: number = 0;
        while (i < result.body.length) {
          this.statesList.push(result.body[i]);
          i = i + 1;
        }
      }
    }, (error: HttpErrorResponse) => {
      this.redirectToLogin(error);
      this.pageErrorMessages.push({
        field: 'Failed to fetch the USA States',
        detail: 'Failed to fetch the USA States. Please refresh the page.',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
    })
  }

  toggleTaxYearsFilter(): any {
    this.taxYearsButton = !this.taxYearsButton;
  }

  trackTaxYears(idValue:number): void {
    //Clear Radio Buttons
    for (const radioButton of this.taxYearsRadioButtons) {
      radioButton.checked = false;
    }
    const taxYearsEl = document.getElementById('flexRadioTaxYears-' + idValue);
    // @ts-ignore
    const taxYearsChecked = taxYearsEl.checked;
    this.taxYearsRadioButtons[idValue]['checked'] = taxYearsChecked;
  }

  populateTaxYearsRadioButtons(): void {
    this.searchGrantsService.getTaxYearsDropdown(this.username).subscribe((result: any) => {
      if (result && result.body) {
        this.taxYearsRadioButtons = result.body;
        if (this.taxYearsRadioButtons.length > 0) {
          // Tax Years are sorted in descending order, most recent tax year is selected by default in
          this.taxYearsRadioButtons[1]['checked'] = true;
        }
      }
    }, (error: HttpErrorResponse) => {
      this.redirectToLogin(error);
      this.pageErrorMessages.push({
        field: 'Failed to fetch the Tax Years',
        detail: 'Failed to fetch the Tax Years. Please refresh the page.',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
    });
  }

  addCauseGivingInterestFilter(addFlag: boolean): void {
    const causeGivingInterestEl = document.getElementById('cause-giving-interests-dropdown-list-id');
    // @ts-ignore
    const causeGivingInterestSelected = causeGivingInterestEl.value;
    if (causeGivingInterestSelected) {
      if (addFlag) {
        this.givingInterestsSetObj[causeGivingInterestSelected] = 0;
        this.recalculateListOfGivingInterests();
      } else {
        this.givingInterestsWithoutSetObj[causeGivingInterestSelected] = 0;
        this.recalculateListOfGivingInterestsWithout();
      }
    }
  }

  recalculateListOfGivingInterests(): void {
    this.causeGivingInterestsList = [];
    for (const givingInterest in this.givingInterestsSetObj) {
      this.causeGivingInterestsList.push(givingInterest);
    }
  }

  recalculateListOfGivingInterestsWithout(): void {
    this.causeGivingInterestsWithoutList = [];
    for (const givingInterestWithout in this.givingInterestsWithoutSetObj) {
      this.causeGivingInterestsWithoutList.push(givingInterestWithout);
    }
  }

  populateCausesDropdown(): void {
    this.searchService.getCausesDropdown(this.username).subscribe((result: any) => {
      if (result && result.body) {
        this.causeDropdownList = result.body;
        this.populateCauseGivingInterestsDropdown();
      }
    }, (error: HttpErrorResponse) => {
      this.pageErrorMessages.push({
        field: 'Failed to fetch the causes and giving interests',
        detail: 'Failed to fetch the causes and giving interests. Please refresh the page.',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
    });
  }

  updateCauseGivingInterestsDropdown(): boolean {
    var causeCategorySel = document.getElementById("cause-category-dropdown-list-id");
    // @ts-ignore
    let causeCategorySelVal = causeCategorySel.value;
    if (causeCategorySel) {
      if (this.causeGivingInterestsObj[causeCategorySelVal]) {
        //this.causeGivingInterestsDropdownList = this.causeGivingInterestsObj[causeCategorySelVal]
        this.causeGivingInterestsDropdownList = this.causeGivingInterestsObj[causeCategorySelVal]
        this.causeGivingInterestsDropdownList = this.causeGivingInterestsDropdownList.concat(
          [{givingInterestDisplayName: 'All Other Cause Category Giving Interests', givingInterestName: 'ALL_OTHER_CAUSE_CATEGORY_GIVING_INTERESTS' }], this.causeGivingInterestsObj['ALL'])
      } else {
        this.causeGivingInterestsDropdownList = this.causeGivingInterestsObj['ALL'];
      }
    }
    return true;
  }

  populateCauseGivingInterestsDropdown(): void {
    this.searchService.getAllGivingInterestsDropdown(this.username).subscribe((result: any) => {
      if (result && result.body) {
        this.causeGivingInterestsObj = result.body;
        this.causeGivingInterestsDropdownList = this.causeGivingInterestsObj['ALL'];
      }
    }, (error: HttpErrorResponse) => {
      this.redirectToLogin(error);
      this.pageErrorMessages.push({
        field: 'Failed to pull the Cause Giving Interests',
        detail: 'Failed to pull the Cause Giving Interests. Please refresh the page.',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
    });
  }


  trackLogicalExpression(logicalOperator: string): void {
    if (logicalOperator == 'AND') {
      this.logicalOperatorAnd = true;
      this.logicalOperatorOr = false;
    } else if (logicalOperator == 'OR') {
      this.logicalOperatorAnd = false;
      this.logicalOperatorOr = true;
    } else {
      this.logicalOperatorAnd = false;
      this.logicalOperatorOr = true;
    }
  }
  recalculateListOfGivingInterests2(causingGivingInterest: string): void {
    if (this.causeGivingInterestsList.length > 0) {
      if (this.logicalOperatorAnd && !this.logicalOperatorOr) {
        this.causeGivingInterestsList.push("AND");
      } else if (!this.logicalOperatorAnd && this.logicalOperatorOr) {
        this.causeGivingInterestsList.push("OR");
      } else {
        this.causeGivingInterestsList.push("OR");
      }
    }
    this.causeGivingInterestsList.push(causingGivingInterest);
  }

  recalculateListOfGivingInterestsWithout2(causingGivingInterest: string): void {
    this.causeGivingInterestsWithoutList.push(causingGivingInterest);
  }

  addCauseGivingInterestFilter2(addFlag: boolean): void {
    const causeGivingInterestEl = document.getElementById('cause-giving-interests-dropdown-list-id');
    // @ts-ignore
    const causeGivingInterestSelected = causeGivingInterestEl.value;
    if (causeGivingInterestSelected) {
      if (addFlag) {
        this.recalculateListOfGivingInterests2(causeGivingInterestSelected);
      } else {
        this.recalculateListOfGivingInterestsWithout2(causeGivingInterestSelected);
      }
    }
  }

  onDeleteGivingInterest(row: string): void {
    const index = this.causeGivingInterestsList.indexOf(row);
    const size = this.causeGivingInterestsList.length;
    const causeGivingInterestsListTemp: string[] = []
    if (size == 1) {
      this.causeGivingInterestsList = [];
      return;
    }
    if (index == (size - 1) ) {
      let excludedSize: number = size - 2;
      let i = 0;
      while (i < excludedSize) {
        causeGivingInterestsListTemp.push(this.causeGivingInterestsList[i]);
        i = i + 1;
      }
      this.causeGivingInterestsList = causeGivingInterestsListTemp;
      return;
    }
    let i = 0;
    while (i < size) {
      if (index == 0 && i == 0 && size > 1) {
        //skip elements 0 and 1
        i = i + 2;
        causeGivingInterestsListTemp.push(this.causeGivingInterestsList[i]);
      } else if (index == i && size > 1) {
        //skip elements i and i + 1
        i = i + 2;
        causeGivingInterestsListTemp.push(this.causeGivingInterestsList[i]);
      } else {
        causeGivingInterestsListTemp.push(this.causeGivingInterestsList[i]);
      }
      i = i + 1;
    }
    this.causeGivingInterestsList = causeGivingInterestsListTemp;
  }

  onDeleteGivingInterestWithout(row: string): void {
    const index = this.causeGivingInterestsWithoutList.indexOf(row);
    const size = this.causeGivingInterestsWithoutList.length;
    const causeGivingInterestsWithoutListTemp: string[] = [];
    let i = 0;
    while (i < size) {
      if (i != index) {
        causeGivingInterestsWithoutListTemp.push(this.causeGivingInterestsWithoutList[i]);
      }
      i = i + 1;
    }
    this.causeGivingInterestsWithoutList = causeGivingInterestsWithoutListTemp;
  }

  onSearch(searchToBeSaved: boolean): any {
    this.loadingIcon = false;
    this.showErrorMessages = false;
    this.errorMessages = [];
    this.showSuccessMessages = false;
    this.successMessages = [];
    this.pageErrorMessages = [];
    this.pageSuccessMessages = [];
    this.sideNavErrorMessages = [];
    //Build search dto from checkboxes
    let nonEmptyFilterFlag : boolean = false;
    this.recipientNames = [];
    const recipientNamesEl = document.getElementById('search-grant-names-text-id');
    // @ts-ignore
    const recipientNamesSelected = recipientNamesEl.value;
    if (recipientNamesSelected) {
      let cleanRecipientNames: string = this.apiService.trimLeadingTrailingSpaces(recipientNamesSelected);
      let recipientNamesFinal: string[] = cleanRecipientNames.split(",");
      if (recipientNamesFinal.length > 10) {
        this.sideNavErrorMessages.push({
          field: 'Filter Error',
          detail: 'Grant Recipient Names limit exceeded. You are limited to 10 names.',
          severity: 'error'
        });
        this.showSideNavErrorMessagesToUser();
        return false;
      }
      for (let i = 0; i < recipientNamesFinal.length; i = i + 1) {
        this.recipientNames.push(this.apiService.trimLeadingTrailingSpaces(recipientNamesFinal[i]));
      }
      nonEmptyFilterFlag = true;
    }

    this.eins = [];
    const einsEl = document.getElementById('eins-text-id');
    // @ts-ignore
    const einsSelected = einsEl.value;
    if (einsSelected) {
      let cleanEins: string = this.apiService.trimLeadingTrailingSpaces(einsSelected);
      let einsFinal: string[] = cleanEins.split(",");
      if (einsFinal.length > 10) {
        this.sideNavErrorMessages.push({
          field: 'Filter Error',
          detail: 'Included Eins limit exceeded. You are limited to 10 eins.',
          severity: 'error'
        });
        this.showSideNavErrorMessagesToUser();
        return false;
      }
      for (let i = 0; i < einsFinal.length; i = i + 1) {
        this.eins.push(this.apiService.trimLeadingTrailingSpaces(einsFinal[i]));
      }
      nonEmptyFilterFlag = true;
    }

    this.cities = [];
    const citiesEl = document.getElementById('cities-text-id');
    // @ts-ignore
    const citiesSelected = citiesEl.value;
    if (citiesSelected) {
      let cleanCities: string = this.apiService.trimLeadingTrailingSpaces(citiesSelected);
      let citiesFinal: string[] = cleanCities.split(",");
      if (citiesFinal.length > 10) {
        this.sideNavErrorMessages.push({
          field: 'Filter Error',
          detail: 'Included Cities limit exceeded. You are limited to 10 cities.',
          severity: 'error'
        });
        this.showSideNavErrorMessagesToUser();
        return false;
      }
      for (let i = 0; i < citiesFinal.length; i = i + 1) {
        let finalCity = this.apiService.trimLeadingTrailingSpaces(citiesFinal[i])
        if (finalCity && !finalCity.startsWith(':')) {
          this.cities.push(finalCity);
        }
      }
      nonEmptyFilterFlag = true;
    }

    this.citiesWithout = [];
    /*
    const citiesWithoutEl = document.getElementById('cities-without-text-id');
    // @ts-ignore
    const citiesWithoutSelected = citiesWithoutEl.value;
    if (citiesWithoutSelected) {
      let cleanCitiesWithout: string = this.apiService.trimLeadingTrailingSpaces(citiesWithoutSelected);
      let citiesWithoutFinal: string[] = cleanCitiesWithout.split(",");
      if (citiesWithoutFinal.length > 10) {
        this.sideNavErrorMessages.push({
          field: 'Filter Error',
          detail: 'Excluded Cities limit exceeded. You are limited to 10 cities.',
          severity: 'error'
        });
        this.showSideNavErrorMessagesToUser();
        return false;
      }
      for (let i = 0; i <citiesWithoutFinal.length; i = i + 1) {
        this.citiesWithout.push(this.apiService.trimLeadingTrailingSpaces(citiesWithoutFinal[i]));
      }
      nonEmptyFilterFlag = true;
    }*/

    this.states = [];
    const usaStateEl = document.getElementById('usa-dropdown-list-id');
    // @ts-ignore
    const usaStateSelected = usaStateEl.value;
    if (usaStateSelected) {
      this.states.push(usaStateSelected);
      nonEmptyFilterFlag = true;
    }

    this.grantAmtMin = -1;
    const grantAmtMinEl = document.getElementById('grant-amt-min-text-id');
    // @ts-ignore
    const grantAmtMinSelected = grantAmtMinEl.value;
    if (grantAmtMinSelected) {
      let grantAmtMinStr = grantAmtMinSelected.replace(',','');
      this.grantAmtMin = parseInt(grantAmtMinStr);
      nonEmptyFilterFlag = true;
    }

    this.grantAmtMax = -1;
    const grantAmtMaxEl = document.getElementById('grant-amt-max-text-id');
    // @ts-ignore
    const grantAmtMaxSelected = grantAmtMaxEl.value;
    if (grantAmtMaxSelected) {
      let grantAmtMaxStr = grantAmtMaxSelected.replace(',','');
      this.grantAmtMax = parseInt(grantAmtMaxStr);
      nonEmptyFilterFlag = true;
    }

    //Time Varying Parameters
    //Tax Year Filter
    this.taxYear = this.taxYearsRadioButtons[1].taxYear;
    for (const taxYearRadioButtonTemp of this.taxYearsRadioButtons) {
      //At least one should always be checked by default
      if (taxYearRadioButtonTemp.checked === true) {
        this.taxYear = taxYearRadioButtonTemp.taxYear;
        nonEmptyFilterFlag = true;
      }
    }

    //Giving Interests build list
    if (this.causeGivingInterestsList.length > 0) {

      nonEmptyFilterFlag = true;
    }

    //Giving Interests Without build list
    if (this.causeGivingInterestsWithoutList.length > 0) {
      nonEmptyFilterFlag = true;
    }
    const browserUrl: string = window.location.href;

    if (this.recipientNames.length == 0 && this.eins.length == 0 && this.states.length == 0 && this.cities.length == 0
      && this.grantAmtMin == -1 && this.grantAmtMax == -1 && this.cause.length == 0 && this.causeGivingInterestsList.length == 0) {
      // Empty search query
      nonEmptyFilterFlag = false;
    }
    this.sortByRecipientNameAscId = 0;
    if (this.recipientNameAscRadioButton) {
      this.sortByRecipientNameAscId = 1;
    } else if (this.recipientNameDescRadioButton) {
      this.sortByRecipientNameAscId = 2;
    }

    this.sortByCityAscId = 0;
    if (this.cityAscRadioButton) {
      this.sortByCityAscId = 1;
    } else if (this.cityDescRadioButton) {
      this.sortByCityAscId = 2;
    }

    this.sortByStateAscId = 0;
    if (this.stateAscRadioButton) {
      this.sortByStateAscId = 1;
    } else if (this.stateDescRadioButton) {
      this.sortByStateAscId = 2;
    }

    this.sortByGrantAmtAscId = 0;
    if (this.grantAmountAscRadioButton) {
      this.sortByGrantAmtAscId = 1;
    } else if (this.grantAmountDescRadioButton) {
      this.sortByGrantAmtAscId = 2;
    }

    const filter: SearchGrantsFilterDto = {
      'recipientNames': this.recipientNames,
      "eins": this.eins,
      'cities': this.cities,
      'citiesWithout': this.citiesWithout,
      'states': this.states,
      'country': '',
      'grantAmtMin': this.grantAmtMin,
      'grantAmtMax': this.grantAmtMax,
      'taxYear': this.taxYear,
      'causeGivingInterests': this.causeGivingInterestsList,
      'causeGivingInterestsWithout': this.causeGivingInterestsWithoutList,
      'sortByRecipientNameAsc': this.sortByRecipientNameAscId,
      'sortByCityAsc': this.sortByCityAscId,
      'sortByStateAsc': this.sortByStateAscId,
      'sortByGrantAmtAsc': this.sortByGrantAmtAscId
    }

    if (!nonEmptyFilterFlag) {
      this.sideNavErrorMessages.push({
        field: 'Filter Error',
        detail: 'Please submit a non empty filter.',
        severity: 'error'
      });
      this.showSideNavErrorMessagesToUser();
      return false;
    }
    let expirationTimestamp: number = Date.now() + 1000*3600*2;
    localStorage.setItem('lastSearchGrant', JSON.stringify(filter));
    localStorage.setItem('lastSearchGrantExpTime', expirationTimestamp.toString());
    this.page = 1;// all new searches default to the first page
    this.pageSize = 100;//default
    const pageDropdownEl = document.getElementById('search-grants-pagination-id-page-size-dropdown-list-id');
    // @ts-ignore
    const newPageSize: number = parseInt(pageDropdownEl.value);
    if (newPageSize) {
      this.pageSize = newPageSize;
    }

    //Submit to API
    // @ts-ignore
    const username: string = localStorage.getItem('username');
    if (searchToBeSaved) {
      const savedSearchNameEl = document.getElementById('saved-search-name-text-id');
      // @ts-ignore
      const savedSearchName = savedSearchNameEl.value;
      this.saveSearchToDatabase(JSON.stringify(filter), username, savedSearchName);
    } else {
      // @ts-ignore
      this.executeSearchPages(browserUrl, this.page, this.pageSize, filter, username);
    }
    return true;
  }

  saveSearchToDatabase(filter: string, username: string, savedSearchName: string) {
    const savedSearchDto: any = {
      savedSearchId: -1,
      userId: -1,
      savedSearchName: savedSearchName,
      searchTypeDto: {
        searchTypeId: this.searchTypeNameMap['GRANT_SEARCH'],
        searchTypeName: 'GRANT_SEARCH'
      },
      savedSearchJson: filter,
      createdTS: new Date(),
      updatedTS: new Date()
    }

    this.userService.editSavedSearch(savedSearchDto, username).subscribe(
      (result: any) => {
        if (result && result.body) {
          this.currentSavedSearchDto = result.body;
          this.getSavedSearches();
          this.successMessages.push({
            field: 'Grant Saved Search Successful',
            detail: 'Successfully updated the saved search name: ' + savedSearchDto.savedSearchName,
            severity: 'success'
          });
          this.showSuccessMessagesToUser();
        }
      }, (err: HttpErrorResponse) => {
        this.errorMessages.push({
          field: 'Grant Saved Search API Failure',
          detail: 'Failed to update the saved search name: ' + savedSearchDto.savedSearchName,
          severity: 'error'
        });
        this.showErrorMessagesToUser();
      }
    );
  }

  onSave(): any {

    return true;
  }

  recalculateObjOfGivingInterests(): void {
    this.givingInterestsSetObj = {};
    for (const givingInterest in this.causeGivingInterestsList) {
      this.givingInterestsSetObj[givingInterest] = 0;
    }
  }
  recalculateObjOfGivingInterestsWithout(): void {
    this.givingInterestsWithoutSetObj = {};
    for (const givingInterestWithout in this.causeGivingInterestsWithoutList) {
      this.givingInterestsWithoutSetObj[givingInterestWithout] = 0;
    }
  }

  deleteGivingInterestChip2(event: Event): void {
    // @ts-ignore
    console.log('deleteGivingInterestChip2: ' + event.currentTarget.value)
    // @ts-ignore
    //delete this.givingInterestsSetObj[event.target.value];
    this.recalculateObjOfGivingInterests();
  }

  deleteGivingInterestWithoutChip2(event: Event): void {
    // @ts-ignore
    console.log('deleteGivingInterestWithoutChip2: ' + event.target.value)
    // @ts-ignore
    //delete this.givingInterestsWithoutSetObj[event.target.value];
    this.recalculateObjOfGivingInterestsWithout();
  }

  deleteGivingInterestChip3(row: any): void {
    // @ts-ignore
    console.log('deleteGivingInterestChip2: ' + JSON.stringify(row));
    let newList: any[] = [];
    for (const rowTemp of this.causeGivingInterestsList) {
      if (rowTemp != row) {
        newList.push(rowTemp);
      }
    }
    this.causeGivingInterestsList = newList;

    this.recalculateObjOfGivingInterests();
  }

  deleteGivingInterestWithoutChip3(row: any): void {
    // @ts-ignore
    console.log('deleteGivingInterestWithoutChip2: ' + JSON.stringify(row));
    let newList: any[] = [];
    for (const rowTemp of this.causeGivingInterestsWithoutList) {
      if (rowTemp != row) {
        newList.push(rowTemp);
      }
    }
    this.causeGivingInterestsWithoutList = newList;
    this.recalculateObjOfGivingInterestsWithout();
  }

  onExportToExcel(): any {
    this.showErrorMessages = false;
    this.errorMessages = [];
    this.showSuccessMessages = false;
    this.successMessages = [];
    this.pageErrorMessages = [];
    this.pageSuccessMessages = [];
    this.sideNavErrorMessages = [];
    if (this.customerTrialVerified) {
      this.pageErrorMessages.push({
        field: 'Cannot Export to CSV',
        detail: 'You are in customer trial mode. You can only export to CSV with a paid subscription.',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser(16000);
      return
    }
    const lastSearchJsonString = localStorage.getItem('lastSearchGrant');
    // @ts-ignore
    const lastSearchFilter: any = JSON.parse(lastSearchJsonString);
    const username = localStorage.getItem('username');
    this.pageSize = 100;//default
    const pageDropdownEl = document.getElementById('search-grants-pagination-id-page-size-dropdown-list-id');
    // @ts-ignore
    const newPageSize: number = parseInt(pageDropdownEl.value);
    if (newPageSize) {
      this.pageSize = newPageSize;
    }
    // @ts-ignore
    this.searchGrantsService.getGrantsPagesInExcel(lastSearchFilter, this.page, this.pageSize, username).subscribe((result: any) => {
      let limitCode = result.headers.get('limitCode');
      //let featureExportLimitRows = result.headers.get('featureExportLimitRows');
      //let featureExportCurrentRows = result.headers.get('featureExportCurrentRows');
      //let featureExportFutureRows = result.headers.get('featureExportFutureRows');
      if (result && result.body) {
        if (limitCode == "2") {
          this.pageErrorMessages.push({
            field: 'Grant Download Failure',
            detail: 'Woah-woah! Our Search Grants tool is meant for online use. You are already at your Weekly limit of 10 downloads.' +
              ' If you need bulk download, please email us to temporarily bump up your limit.',
            severity: 'error'
          });
          this.showPageErrorMessagesToUser();
        } else if (limitCode == "1") {
          this.pageErrorMessages.push({
            field: 'Grant Download Warning',
            detail: 'Woah-woah! Our Search Grants tool is meant for online use. You are already at your Daily limit of 2 downloads.' +
              ' If you need bulk download, please email us to temporarily bump up your limit.',
            severity: 'error'
          });
          this.showPageErrorMessagesToUser();
        } else {
          let file_name: string = "grants.csv";
          saveAs(result.body, file_name);
          this.pageSuccessMessages.push({
            field: 'Grant Export Successful',
            detail: 'Grants successfully exported to csv...',
            severity: 'success'
          });
          this.showPageSuccessMessagesToUser();
        }
      }
      this.closeNav();
    }, (err: HttpErrorResponse) => {
      this.redirectToLogin(err);
      if (err.error && err.error.limitCode == 2) {
        this.pageErrorMessages.push({
          field: 'Oops! You’ve Reached Your Daily Download Limit',
          detail: 'It looks like you’ve hit the maximum number of downloads for today. No worries! You can pick up right where you left off tomorrow, or if you need immediate access to more downloads, feel free to reach out to our support team—we\'re here to help! Thank you for using Scalanthropy! We appreciate your understanding, and we\'re always working to make your experience better.',
          severity: 'error'
        });
        this.showPageErrorMessagesToUser(16000);
      } else if (err.error && err.error.limitCode == 1) {
        this.pageErrorMessages.push({
          field: 'Grant Export Warning',
          detail: 'Woah-woah! Our Search Grants tool is meant for online use. You will exceed at your limit of ' + err.error.featureExportLimitRows + ' rows.' +
            ' You need to downsize your query.',
          severity: 'error'
        });
        this.showPageErrorMessagesToUser(16000);
      } else {
        this.pageErrorMessages.push({
          field: 'Grant Export Failure',
          detail: 'Failed to export the grants to csv...',
          severity: 'error'
        });
        this.showPageErrorMessagesToUser();
      }
    });

    return true;
  }

  toggle(): boolean {
    if (!this.isSideNavOpened) {
      this.openNav();
    } else {
      this.closeNav();
    }
    return true;
  }
  openNav() {
    // @ts-ignore
    const element = document.getElementById("mySidenav");
    if (element) {
      element.style.width = "70%"
      // @ts-ignore
      element.style['padding-left'] = "20px";
      this.isSideNavOpened = true;
    }
  }

  /* Set the width of the side navigation to 0 */
  closeNav() {
    // @ts-ignore
    const element = document.getElementById("mySidenav");
    if (element) {
      element.style.width = "0";
      // @ts-ignore
      element.style['padding-left'] = "0px";
      this.isSideNavOpened = false;
    }
  }

  toggleRecipientNameAscButton(): void {
    this.recipientNameAscRadioButton = !this.recipientNameAscRadioButton;

    if (this.recipientNameAscRadioButton && this.recipientNameDescRadioButton) {
      this.recipientNameAscRadioButton = true;
      this.recipientNameDescRadioButton = false;
    }
  }

  toggleRecipientNameDescButton(): void {
    this.recipientNameDescRadioButton = !this.recipientNameDescRadioButton;
    if (this.recipientNameAscRadioButton && this.recipientNameDescRadioButton) {
      this.recipientNameAscRadioButton = false;
      this.recipientNameDescRadioButton = true;
    }
  }

  toggleCityAscButton(): void {
    this.cityAscRadioButton = !this.cityAscRadioButton;
    if (this.cityAscRadioButton && this.cityDescRadioButton) {
      this.cityAscRadioButton = true;
      this.cityDescRadioButton = false;
    }
  }

  toggleCityDescButton(): void {
    this.cityDescRadioButton = !this.cityDescRadioButton;
    if (this.cityAscRadioButton && this.cityDescRadioButton) {
      this.cityAscRadioButton = false;
      this.cityDescRadioButton = true;
    }
  }

  toggleStateAscButton(): void {
    this.stateAscRadioButton = !this.stateAscRadioButton;
    if (this.stateAscRadioButton && this.stateDescRadioButton) {
      this.stateAscRadioButton = true;
      this.stateDescRadioButton = false;
    }
  }

  toggleStateDescButton(): void {
    this.stateDescRadioButton = !this.stateDescRadioButton;
    if (this.stateAscRadioButton && this.stateDescRadioButton) {
      this.stateAscRadioButton = false;
      this.stateDescRadioButton = true;
    }
  }

  toggleGrantAmountAscButton(): void {
    this.grantAmountAscRadioButton = !this.grantAmountAscRadioButton;
    if (this.grantAmountAscRadioButton && this.grantAmountDescRadioButton) {
      this.grantAmountAscRadioButton = true;
      this.grantAmountDescRadioButton = false;
    }
  }

  toggleGrantAmountDescButton(): void {
    this.grantAmountDescRadioButton = !this.grantAmountDescRadioButton;
    if (this.grantAmountAscRadioButton && this.grantAmountDescRadioButton) {
      this.grantAmountAscRadioButton = false;
      this.grantAmountDescRadioButton = true;
    }
  }

  sortTextRecipientOfGrantName(): void {
    if (!this.sortedAscRecipientOfGrantHeaderButton) {
      this.recipientNameAscRadioButton = false;
      this.recipientNameDescRadioButton = true;
      this.cityAscRadioButton = false;
      this.cityDescRadioButton = false;
      this.stateAscRadioButton = false;
      this.stateDescRadioButton = false;
      this.grantAmountAscRadioButton = false;
      this.grantAmountDescRadioButton = false;
    } else {
      this.recipientNameAscRadioButton = true;
      this.recipientNameDescRadioButton = false;
      this.cityAscRadioButton = false;
      this.cityDescRadioButton = false;
      this.stateAscRadioButton = false;
      this.stateDescRadioButton = false;
      this.grantAmountAscRadioButton = false;
      this.grantAmountDescRadioButton = false;
    }
    this.sortedAscRecipientOfGrantHeaderButton = !this.sortedAscRecipientOfGrantHeaderButton;
    this.populateResultsFromLastSearch(true);
  }

  sortTextCity(): void {
    if (!this.sortedAscCityHeaderButton) {
      this.cityAscRadioButton = false;
      this.cityDescRadioButton = true;
      this.stateAscRadioButton = false;
      this.stateDescRadioButton = false;
      this.grantAmountAscRadioButton = false;
      this.grantAmountDescRadioButton = false;
      this.recipientNameAscRadioButton = false;
      this.recipientNameDescRadioButton = false;
    } else {
      this.cityAscRadioButton = true;
      this.cityDescRadioButton = false;
      this.stateAscRadioButton = false;
      this.stateDescRadioButton = false;
      this.grantAmountAscRadioButton = false;
      this.grantAmountDescRadioButton = false;
      this.recipientNameAscRadioButton = false;
      this.recipientNameDescRadioButton = false;
    }
    this.sortedAscCityHeaderButton = !this.sortedAscCityHeaderButton;
    this.populateResultsFromLastSearch(true);
  }

  sortTextState(): void {
    if (!this.sortedAscStateHeaderButton) {
      this.cityAscRadioButton = false;
      this.cityDescRadioButton = false;
      this.stateAscRadioButton = false;
      this.stateDescRadioButton = true;
      this.grantAmountAscRadioButton = false;
      this.grantAmountDescRadioButton = false;
      this.recipientNameAscRadioButton = false;
      this.recipientNameDescRadioButton = false;
    } else {
      this.cityAscRadioButton = false;
      this.cityDescRadioButton = false;
      this.stateAscRadioButton = true;
      this.stateDescRadioButton = false;
      this.grantAmountAscRadioButton = false;
      this.grantAmountDescRadioButton = false;
      this.recipientNameAscRadioButton = false;
      this.recipientNameDescRadioButton = false;
    }
    this.sortedAscStateHeaderButton = !this.sortedAscStateHeaderButton;
    this.populateResultsFromLastSearch(true);
  }

  sortNumberCashGrantAmt(): void {
    if (!this.sortedAscCashGrantAmtHeaderButton) {
      this.grantAmountAscRadioButton = false;
      this.grantAmountDescRadioButton = true;
      this.cityAscRadioButton = false;
      this.cityDescRadioButton = false;
      this.stateAscRadioButton = false;
      this.stateDescRadioButton = false;
      this.recipientNameAscRadioButton = false;
      this.recipientNameDescRadioButton = false;
    } else {
      this.grantAmountAscRadioButton = true;
      this.grantAmountDescRadioButton = false;
      this.cityAscRadioButton = false;
      this.cityDescRadioButton = false;
      this.stateAscRadioButton = false;
      this.stateDescRadioButton = false;
      this.recipientNameAscRadioButton = false;
      this.recipientNameDescRadioButton = false;
    }
    this.sortedAscCashGrantAmtHeaderButton = !this.sortedAscCashGrantAmtHeaderButton;
    this.populateResultsFromLastSearch(true);
  }

  onViewGrantDetails(row: any) {
    //Grant Details Route
    this.routerChild.navigateByUrl('app/search/grants/donors/' + row['donorRecipientMappingId'] + '/recipients/' + row['recipientId'] + '/details');
  }
}
